export default __webpack_public_path__ + "static/media/ic_type_challenge.4150598f.svg";